// ** Locale cascade for the shared Pronto-Posto multi-account service.
//
// Language is resolved by a cascade (weakest -> strongest):
//   1. navigator.language        (browser preference, pre-login)
//   2. ?lang= URL parameter      (explicit override, pre-login)
//   3. logged-in account         (username -> language, strongest; post-login)
//
// Used by configs/i18n (boot language) and views/apps/email/index.js
// (re-apply on mount for fresh login / account switch without reload) and
// views/pages/authentication/Login.js (apply immediately on login success).

export const SUPPORTED = ['de', 'en', 'fr', 'es', 'it']
export const DEFAULT_LNG = 'de'

// Account username -> shell language. One deployment serves every case/account,
// so only the logged-in account can decide the language.
// KS04 accounts follow the final printed credentials; ES uses a.grande.
export const accountToLang = username => {
  switch (username) {
    case 'rafaela-silva':
      return 'en' // KS03 EN-UK
    case 'maxwell.lang':
      return 'en' // KS04 EN-UK
    case 'm.legrand':
      return 'fr' // KS04 FR
    case 'm.lunghi':
      return 'it' // KS04 IT
    case 'a.grande':
      return 'es' // KS04 ES
    default:
      return 'de' // m.lange (KS04 DE), raf.silva (KS03 DE), rossi/novak (KS02)
  }
}

// Map any BCP-47 tag / value to a supported base language, or null if unsupported.
const normalize = value => {
  if (!value) return null
  const base = String(value).toLowerCase().split(/[-_]/)[0]
  return SUPPORTED.includes(base) ? base : null
}

// Pre-login: ?lang= overrides navigator.language; falls back to DEFAULT_LNG.
export const resolvePreLoginLang = () => {
  try {
    const fromQuery = normalize(new URLSearchParams(window.location.search).get('lang'))
    if (fromQuery) return fromQuery
    const nav = window.navigator
    const fromNav = normalize(nav.language || (nav.languages && nav.languages[0]))
    if (fromNav) return fromNav
  } catch (e) {
    /* SSR / no window — fall through */
  }
  return DEFAULT_LNG
}

// Full boot cascade: a logged-in account wins over the pre-login signals.
export const resolveInitialLng = () => {
  try {
    const userData = JSON.parse(window.localStorage.getItem('userData'))
    if (userData && userData.username) return accountToLang(userData.username)
  } catch (e) {
    /* not logged in / bad JSON — fall through to pre-login */
  }
  return resolvePreLoginLang()
}
